import type { FieldKind } from './field-kind.js';

/**
 * Max-width tokens for form controls (`ch` in CSS).
 * SSOT rules: docs/frontend/form-field-sizing.md
 */
export type FieldControlWidthToken =
  | 'text'
  | 'textarea'
  | 'document'
  | 'phone'
  | 'enum'
  | 'date'
  | 'cep'
  | 'uf'
  | 'number'
  | 'radio'
  | 'plate'
  | 'sku'
  | 'mileage';

const FIELD_CONTROL_WIDTH: Record<FieldKind, FieldControlWidthToken> = {
  name: 'text',
  legalName: 'text',
  tradeName: 'text',
  street: 'text',
  neighborhood: 'text',
  reference: 'text',
  textarea: 'textarea',
  owner: 'text',
  full: 'text',
  nickname: 'text',
  brand: 'text',
  model: 'text',
  chassis: 'text',
  contactValue: 'text',
  complement: 'text',
  city: 'text',
  occupation: 'text',
  jobTitle: 'text',
  readOnly: 'text',
  date: 'date',
  gender: 'enum',
  taxonomy: 'enum',
  personType: 'radio',
  channel: 'enum',
  color: 'enum',
  serviceCode: 'enum',
  duration: 'number',
  document: 'document',
  rg: 'document',
  phone: 'phone',
  cep: 'cep',
  uf: 'uf',
  number: 'number',
  plate: 'plate',
  sku: 'sku',
  year: 'number',
  mileage: 'mileage',
};

export function resolveFieldControlWidthToken(kind: FieldKind): FieldControlWidthToken {
  return FIELD_CONTROL_WIDTH[kind];
}

export function resolveFieldControlWidthClass(kind: FieldKind): string {
  return `field-control--${resolveFieldControlWidthToken(kind)}`;
}

const FIELD_MAX_WIDTH: Record<FieldControlWidthToken, string> = {
  text: '50ch',
  textarea: '50ch',
  document: '25ch',
  phone: '25ch',
  enum: '25ch',
  date: '25ch',
  cep: '10ch',
  uf: '4ch',
  number: '10ch',
  radio: 'max-content',
  plate: '10ch',
  sku: '14ch',
  mileage: '20ch',
};

/** CSS length for `--field-max-width` on {@link FormGridCol}. */
export function resolveFieldMaxWidth(kind: FieldKind): string {
  return FIELD_MAX_WIDTH[resolveFieldControlWidthToken(kind)];
}
